// @ts-nocheck 

import React, { useState, useEffect } from 'react';
import { Joyride, Step, CallBackProps, STATUS, ACTIONS, EVENTS } from 'react-joyride';
import { UserState, userStore } from '../../api/AuthService';
import { ApiService } from '../../api/ApiService';

interface LayoutProps {
  children: React.ReactNode;
}

export var runStatus = false;

const steps: Step[] = [
  // ALL HAPPEN ON HOME PAGE
  {
    content: <h2>Welcome to the Lp Pro App!</h2>,
    target: 'body',
    placement: 'center',
  },
  {
    content: <h2>This will walk you through how to use it.</h2>,
    target: 'body',
    placement: 'center',
  },
  {
    content: <h3>From here, you can access any of the app’s five main sections.</h3>,
    target: '#navi',
    placement: 'top',
  },
  {
    target: '#toolbar-image',
    content: <h3>You can open the side navbar by clicking the toolbar image.</h3>,
    disableBeacon: true,
    placement: 'bottom',
    spotlightClicks: true,
    hideFooter: true, 
  },
  // {
  //   target: '.HomeNotificationLink',
  //   content: 'At the top right, you can access your messages, notifications, and settings.',
  //   disableBeacon: true,
  //   placement: 'bottom',
  // },
  // // THis is for the MEssage page. 
  // {
  //   target: '#HomeMessageLink',
  //   content: 'Click here to see your messages.',
  //   disableBeacon: true,
  //   placement: 'bottom',
  //   spotlightClicks: true,
  //   hideFooter: true, 
  // },
  // {
  //   target: '#new_message',
  //   content: 'You can create a message by clicking here.',
  //   disableBeacon: true,
  //   placement: 'top',
  // },

  // // This is for the Notification Page
  // {
  //   target: '#InboxNotificationLink',
  //   content: 'Click here to see your notifications.',
  //   disableBeacon: true,
  //   placement: 'bottom',
  //   spotlightClicks: true,
  //   hideFooter: true, 
  // },
  // {
  //   content: 'Any notifications from the system will pop up here.',
  //   target: '.notification-card-read',
  //   placement: 'bottom',
  // },

  //   // This is for the Setting page
  //   {
  //     target: '#NotificationHubSettingLink',
  //     content: 'Click here to view application settings.',
  //     disableBeacon: true,
  //     placement: 'bottom',
  //     spotlightClicks: true,
  //     hideFooter: true, 
  //   },
  //   {
  //     content: 'This is the setting page, you can check the version and view general terms here.',
  //     target: 'body',
  //     placement: 'center',
  //   },

  // // This happens for the homepage 
  // {
  //   target: '#SettingsnavHomeMain',
  //   content: 'Click here and return back to the home page',
  //   disableBeacon: true,
  //   placement: 'bottom',
  //   spotlightClicks: true,
  //   hideFooter: true, 
  // },
  {
    target: '#WalkThroughFeature1',
    content: <h3>You can access your truck's registration from here.</h3>,
    disableBeacon: true,
    placement: 'bottom',
    disableScrolling: true,
  },
  {
    target: '#WalkThroughFeature2',
    content: <h3>Need answers? Open Frequently Asked Questions from here.</h3>,
    disableBeacon: true,
    placement: 'bottom',
    disableScrolling: true,
  },
  {
    target: '#WalkThroughFeature3',
    content: <h3>Cruise down here to find important company contact information!</h3>,
    disableBeacon: true,
    placement: 'bottom',
    disableScrolling: true,
  },
  {
    target: '#HomeSettingLink',
    content: <h3>To view this walkthrough again, go to the settings page and click Reset Walkthrough</h3>,
    disableBeacon: true,
    placement: 'bottom',
  },
  {
    content: <h3>Select any page to learn more!</h3>,
    target: 'body',
    placement: 'center',
  },

  // // ALL HAPPEN for LOAD PAGE
  // {
  //   target: '#HomenavLoadMain',
  //   content: 'Click here to view the load page.',
  //   disableBeacon: true,
  //   placement: 'top',
  //   spotlightClicks: true,
  //   hideFooter: true, 
  // },
  // {
  //   target: '#loadPage',
  //   content: 'The Load page displays your upcoming, current, and past load information.',
  //   disableBeacon: true,
  //   placement: 'bottom',
  // },
  // //  ALL HAPPEN for TRIP PAGE
  // {
  //   target: '#LoadnavTripMain',
  //   content: 'Click here to view the trip page.',
  //   disableBeacon: true,
  //   placement: 'top',
  //   spotlightClicks: true,
  //   hideFooter: true, 
  // },
  // {
  //   content: 'The trip page contains tools to help you manage and document your load.',
  //   target: 'body',
  //   placement: 'center',
  // },
  // {
  //   target: '#AvaTrailer',
  //   content: 'The available trailer tool helps you find empty and available trailers.',
  //   disableBeacon: true,
  //   placement: 'bottom',
  // },
  // // ALL HAPPENING for PAY PAGE
  // {
  //   target: '#TripnavMoneyMain',
  //   content: 'Click here to view the pay page.',
  //   disableBeacon: true,
  //   placement: 'top',
  //   spotlightClicks: true,
  //   hideFooter: true, 
  // },
  // {
  //   target: '#WholeMoneySection',
  //   content: 'The pay page contains your current and past pay information, as well as the option to request cash advances.',
  //   disableBeacon: true,
  //   placement: 'bottom',
  // },
  // {
  //   target: '#WestLinks',
  //   content: 'Support and questions can be answer through these contacts',
  //   disableBeacon: true,
  //   placement: 'bottom',
  // },
  //   // ALL HAPPENING for Doc Page
  // {
  //   target: '#MoneynavDocsMain',
  //   content: 'Click here to view the docs page.',
  //   disableBeacon: true,
  //   placement: 'top',
  //   spotlightClicks: true,
  //   hideFooter: true, 
  // },
  // {
  //   target: '#WholeDocsSection',
  //   content: 'The Docs page contains helpful videos and documents related to safety, maintenance, and your employment',
  //   disableBeacon: true,
  //   placement: 'bottom',
  // },
  // {
  //   target: '#Accident',
  //   content: 'This section contains information on what to do after an accident.',
  //   disableBeacon: true,
  //   placement: 'bottom',
  // },
  // {
  //   content: <h2>You’ve completed the walkthrough! Happy driving!</h2>,
  //   target: 'body',
  //   placement: 'center',
  // },
];

export default function FirstSignIn({ children }: LayoutProps) {
  const [run, setRun] = useState(false);
  const [stepIndex,setStepIndex] = useState(0);

  

//   █████████   ███████████  █████      █████████  ██████████ ███████████     █████████  ██████████ ███████████
//   ███░░░░░███ ░░███░░░░░███░░███      ███░░░░░███░░███░░░░░█░█░░░███░░░█    ███░░░░░███░░███░░░░░█░█░░░███░░░█
//  ░███    ░███  ░███    ░███ ░███     ███     ░░░  ░███  █ ░ ░   ░███  ░    ░███    ░░░  ░███  █ ░ ░   ░███  ░ 
//  ░███████████  ░██████████  ░███    ░███          ░██████       ░███       ░░█████████  ░██████       ░███    
//  ░███░░░░░███  ░███░░░░░░   ░███    ░███    █████ ░███░░█       ░███        ░░░░░░░░███ ░███░░█       ░███    
//  ░███    ░███  ░███         ░███    ░░███  ░░███  ░███ ░   █    ░███        ███    ░███ ░███ ░   █    ░███    
//  █████   █████ █████        █████    ░░█████████  ██████████    █████      ░░█████████  ██████████    █████   
// ░░░░░   ░░░░░ ░░░░░        ░░░░░      ░░░░░░░░░  ░░░░░░░░░░    ░░░░░        ░░░░░░░░░  ░░░░░░░░░░    ░░░░░    
                                                                                                                                                                                                                       
  // This is the appMap variable which will show whether its a person's first time on each page.
  const { appMap } = userStore((state: UserState) => ({ appMap: state.appMap }));

  useEffect(() => {
    if (appMap && !appMap.Home) {
      const updatedMap = { ...appMap, Home: true };
      userStore.setState({ appMap: updatedMap });
      ApiService.setDriverMap("login", { appMap: JSON.stringify(updatedMap) });
      // Delay start so the Home page DOM has time to fully render before Joyride
      // tries to locate targets like #navi, #WalkThroughFeature1, etc.
      setTimeout(() => {
        setRun(true);
        runStatus = true;
      }, 800);
    }
  }, [])

  // This useffect triggers on every stepindex so it scrolls to the locations of the next element
  useEffect(() => {

      const step = steps[stepIndex]; // Get the current step
      if (step?.target && typeof step.target === 'string') { 
        const targetElement = document.querySelector(step.target);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'instant' as ScrollBehavior, block: 'nearest'});
        }
      }
  }, [stepIndex]);



  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action, index, type, step } = data;

    if (step.spotlightClicks === true) {
      document.body.classList.add('joyride-spotlight-clicks');
    } else {
      document.body.classList.remove('joyride-spotlight-clicks');
    }

    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      setRun(false);
      runStatus = false;
      setStepIndex(0);
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
  }

//   █████████                      █████    ████   ███           █████       █████   
//   ███░░░░░███                    ░░███    ░░███  ░░░           ░░███       ░░███    
//  ░███    ░░░  ████████   ██████  ███████   ░███  ████   ███████ ░███████   ███████  
//  ░░█████████ ░░███░░███ ███░░███░░░███░    ░███ ░░███  ███░░███ ░███░░███ ░░░███░   
//   ░░░░░░░░███ ░███ ░███░███ ░███  ░███     ░███  ░███ ░███ ░███ ░███ ░███   ░███    
//   ███    ░███ ░███ ░███░███ ░███  ░███ ███ ░███  ░███ ░███ ░███ ░███ ░███   ░███ ███
//  ░░█████████  ░███████ ░░██████   ░░█████  █████ █████░░███████ ████ █████  ░░█████ 
//   ░░░░░░░░░   ░███░░░   ░░░░░░     ░░░░░  ░░░░░ ░░░░░  ░░░░░███░░░░ ░░░░░    ░░░░░  
//               ░███                                     ███ ░███                     
//               █████                                   ░░██████                      
//              ░░░░░                                     ░░░░░░          
  // This useffect will load in all the query listeners for different clicks on the spotlight to trigger different effects depending on whats clicked inside the spotlight
  // tne section inside if (spotlight) can be used to add new stepindex and other functionalities when the clicked spotlight area does contains a specific id or class.
  useEffect(() => {
    const handleSpotlightClick = (event: MouseEvent | TouchEvent) => {
      const spotlight = document.querySelector('.react-joyride__spotlight');
      const target = event.target as HTMLElement;
  
      if (spotlight) {

        // if for the toolbar-image click
        if (target.id === 'toolbar-image') {
          setTimeout(() => {
            setStepIndex((prev) => prev + 1);
          }, 300);
        }

        if (target.id === 'HomeMessageLink') {
            setTimeout(() => {
              setStepIndex((prev) => prev + 1);   
            }, 600); 
        }

        if (target.id === 'InboxNotificationLink') {
          setTimeout(() => {
              setStepIndex((prev) => prev + 1);
          },300); 
        }

        if (target.id === 'NotificationHubSettingLink') {
          setTimeout(() => {
              setStepIndex((prev) => prev + 1);
          },300); 
        }

        if (target.id === 'SettingsnavHomeMain') {
          setTimeout(() => {
              setStepIndex((prev) => prev + 1);
          },300); 
        }

        if (target.id === 'HomenavLoadMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#loadPage"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }

        if (target.id === 'LoadnavTripMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#AvaTrailer"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }

        if (target.id === 'TripnavMoneyMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#WholeMoneySection"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }
        
        if (target.id === 'MoneynavDocsMain') {
          setTimeout(() => {
            const navbar = document.querySelector("#WholeDocsSection"); // added a check for navbar because the index was triggering too fast. (before nav load)s
            if (navbar) {
              setStepIndex((prev) => prev + 1);
            }
          },300);     
        }
      }
    };
  
    // Add event listener only if Joyride is running
    if (run) {
      document.addEventListener('click', handleSpotlightClick);
    }
  
    return () => {
      document.removeEventListener('click', handleSpotlightClick);
    };
  }, [run]); 
  
//  ███████████             █████                                   
// ░░███░░░░░███           ░░███                                    
//  ░███    ░███   ██████  ███████   █████ ████ ████████  ████████  
//  ░██████████   ███░░███░░░███░   ░░███ ░███ ░░███░░███░░███░░███ 
//  ░███░░░░░███ ░███████   ░███     ░███ ░███  ░███ ░░░  ░███ ░███ 
//  ░███    ░███ ░███░░░    ░███ ███ ░███ ░███  ░███      ░███ ░███ 
//  █████   █████░░██████   ░░█████  ░░████████ █████     ████ █████
// ░░░░░   ░░░░░  ░░░░░░     ░░░░░    ░░░░░░░░ ░░░░░     ░░░░ ░░░░░ 
                                                                 
  return (
    <div>
      <Joyride
        run={run}
        steps={steps}
        stepIndex={stepIndex}
        onEvent={handleJoyrideCallback}
        continuous
        locale={{ last: 'Finish' }}
        options={{
          arrowColor: 'rgb(238, 238, 238)',
          backgroundColor: 'rgb(238, 238, 238)',
          overlayColor: 'rgba(0, 0, 0, 0.64)',
          primaryColor: '#000',
          textColor: 'rgb(0, 0, 0)',
          width: 900,
          zIndex: 1000,
          buttons: ['primary', 'skip'],
          dismissKeyAction: false,
          overlayClickAction: false,
        }}
        styles={{
          buttonPrimary: {
            fontSize: '1.2rem',
            padding: '10px 25px',
            fontWeight: '700',
          },
          buttonSkip: {
            fontSize: '1.2rem',
            padding: '10px 25px',
            fontWeight: '700',
          }
        }}
      />

      {children}
    </div>
  );
}
